// Stimulus controllers are registered here by hand.
import { application } from "./application"

import SuggestedRateController from "./suggested_rate_controller"
application.register("suggested-rate", SuggestedRateController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)
